exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-js .vjs-fluid[data-v-09f3b4d8] {\n    width: auto;\n    height: auto;\n    max-height: 395px !important;\n}\n.player[data-v-09f3b4d8] {\n    /* position: absolute !important; */\n    width: 100%;\n    height: 60%;\n}\n.vjs-custom-skin[data-v-09f3b4d8] {\n    height: 60% !important;\n}\n.vjs-custom-skin[data-v-09f3b4d8] .video-js {\n    height: 60%;\n}\n.player-fit[data-v-09f3b4d8] {\n    position: relative !important;\n    width: 100% !important;\n    height: auto !important;\n}\n\n", ""]);

// exports
